<template>
    <div>

        <InfoBox modalName="HotspotNSC">
            <template #title>Bau des Sarkophages</template>
            <template #subline></template>
            <template>
                <p> 
                <ZDFPlayer data-jsb='{"config":"https://3d.zdf.de/Tschernobyl/video/3Dconfiguration.json", "content":"https://3d.zdf.de/Tschernobyl/video/200420_Tschernobyl_Hotspot_Maz_NeuerSarkophag_Web.json"}'></ZDFPlayer>
                </p>
                <p>Die Schutzhülle wird zunächst vor dem Reaktor zusammengebaut und dann Stück für Stück auf Schienen über den
                alten Beton-Sarkophag geschoben.
                   
                </p>
            </template>
        </InfoBox>
    
        <Fallback>
            <picture>
                <source media="(orientation: portrait)" srcset="../assets/img/fallback/08_NSC_Groesse_iPad_P.jpg">
                <source media="(orientation: landscape)" srcset="../assets/img/fallback/08_NSC_Groesse_iPad_L.jpg">
                <!-- The img element is required as the last child tag of the picture declaration block. The img element is used to provide backward compatibility for browsers that do not support the picture element, or if none of the source tags matched. -->
                <img src="../assets/img/fallback/Infobox.png" alt="">
            </picture>
            <div class="hotspot" v-on:click="infobox('HotspotNSC')"></div>      
        </Fallback>



    </div>
</template>



<script>
    export default {
        name: 'NSC_Groesse',
        babylonState: {
            moveCamera: [-7.2, 1.3, 17, 26.4 ,1,1],    

            hotspot: {
                visible: true,
                infoBox: 'HotspotNSC', // Muss zur Infobox oben passen!
                position: [27, 5, 1],
                backFaceCulling: 1,
                scale: 2,
                //scale: 0,

            },


            Geo_Tschernobyl: {

                children: {

                    BG_Sphere: true,
                    
                    Geo_Beton_Sarkophag: false,
                    Geo_Beton_Sarkophag_Rost: true,
                    Geo_Schattenplane_Betonsarkophag: true,
                    Geo_Textur1_Reaktor_4_Damage: false,
                    Geo_Textur1_Reaktor_4_Damage_Aussen: false,
                    Geo_Textur1_Reaktor_4_Damage_Innen: false,

                    Geo_Neuer_Sarkophag_startpos_transparent: true,
                    Geo_Schienen_Sarkophag: true,
                    Geo_Schattenplane_NSC_startpos: true,

                    Geo_Pfeil_108m: true,
					Geo_Pfeil_162m: true,
					Geo_Pfeil_257m: true,
					Geo_Typo_108m: true,
					Geo_Typo_162m: true,
                    Geo_Typo_275m: true,


                    

                },

            },

            fire: false
        },

        babylonReady: function () {

            //this.$audioController.initTrack('speaker', require('./../assets/audio/Uebergang_01.mp3'), false, true);

            this.$babylonController.setAutoRotateBehaviour(false),
            this.$babylonController.setCameraRadiusLimit (3,50),
            this.$babylonController.zoomCamera(1.2)
            
        },

    }
</script>

<style scoped lang="scss">

    .fallback-container .hotspot {
        
        left: 65vw;
        top: 40vh;

        @media (orientation: landscape) {
            left: 60vw;
            top: 35vh;
            transform: scale(0.75);            
        }
    }


</style>
